// App-side delegate for `@heidi/templates/data`.
// isAuthenticated crosses the package seam as a plain boolean; the
// module-scope invalidator moved with the hook and now takes the app's
// queryClient from the `configureTemplatesData` seam.
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { GET_INITIAL_PINNED_TEMPLATES } from '@heidi/templates/contracts';
import {
  invalidateInitialPinnedTemplates,
  useQueryInitialPinnedTemplates as useQueryInitialPinnedTemplatesCore,
} from '@heidi/templates/data';

export { GET_INITIAL_PINNED_TEMPLATES, invalidateInitialPinnedTemplates };

export function useQueryInitialPinnedTemplates(options?: { enabled?: boolean }) {
  const { isAuthenticated } = useIsAuthenticated();

  return useQueryInitialPinnedTemplatesCore(options, isAuthenticated);
}
